/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAbsence } from '../models/work-absence';
import { WorkAddDocumentDto } from '../models/work-add-document-dto';
import { WorkCreateAbsenceV2Dto } from '../models/work-create-absence-v-2-dto';
import { WorkOpenAbsencesScopeEnum } from '../models/work-open-absences-scope-enum';
import { WorkRemoveDocumentDto } from '../models/work-remove-document-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateAbsenceV2Dto } from '../models/work-update-absence-v-2-dto';

@Injectable({ providedIn: 'root' })
export class WorkAbsencesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `absencesV2ControllerFindOpenAbsencesForSupervisor()` */
  static readonly AbsencesV2ControllerFindOpenAbsencesForSupervisorPath = '/v2/absences/open-for-supervisor';

  /**
   * Required permissions: absences:read, absences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `absencesV2ControllerFindOpenAbsencesForSupervisor()` instead.
   *
   * This method doesn't expect any request body.
   */
  absencesV2ControllerFindOpenAbsencesForSupervisor$Response(
    params?: {
      scope?: WorkOpenAbsencesScopeEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAbsence>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAbsencesV2Service.AbsencesV2ControllerFindOpenAbsencesForSupervisorPath, 'get');
    if (params) {
      rb.query('scope', params.scope, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAbsence>>;
      })
    );
  }

  /**
   * Required permissions: absences:read, absences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `absencesV2ControllerFindOpenAbsencesForSupervisor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  absencesV2ControllerFindOpenAbsencesForSupervisor(
    params?: {
      scope?: WorkOpenAbsencesScopeEnum;
    },
    context?: HttpContext
  ): Observable<Array<WorkAbsence>> {
    return this.absencesV2ControllerFindOpenAbsencesForSupervisor$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAbsence>>): Array<WorkAbsence> => r.body)
    );
  }

  /** Path part for operation `absencesV2ControllerFindByUserId()` */
  static readonly AbsencesV2ControllerFindByUserIdPath = '/v2/absences/byUserId/{userId}';

  /**
   * Required permissions: absences:read, absences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `absencesV2ControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  absencesV2ControllerFindByUserId$Response(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAbsence>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAbsencesV2Service.AbsencesV2ControllerFindByUserIdPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAbsence>>;
      })
    );
  }

  /**
   * Required permissions: absences:read, absences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `absencesV2ControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  absencesV2ControllerFindByUserId(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkAbsence>> {
    return this.absencesV2ControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAbsence>>): Array<WorkAbsence> => r.body)
    );
  }

  /** Path part for operation `absencesV2ControllerDelete()` */
  static readonly AbsencesV2ControllerDeletePath = '/v2/absences/{id}';

  /**
   * Required permissions: absences:delete, absences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `absencesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  absencesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAbsencesV2Service.AbsencesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: absences:delete, absences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `absencesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  absencesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.absencesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `absencesV2ControllerUpdate()` */
  static readonly AbsencesV2ControllerUpdatePath = '/v2/absences/{id}';

  /**
   * Required permissions: absences:update, absences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `absencesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateAbsenceV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbsence>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAbsencesV2Service.AbsencesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbsence>;
      })
    );
  }

  /**
   * Required permissions: absences:update, absences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `absencesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateAbsenceV2Dto
    },
    context?: HttpContext
  ): Observable<WorkAbsence> {
    return this.absencesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbsence>): WorkAbsence => r.body)
    );
  }

  /** Path part for operation `absencesV2ControllerCreate()` */
  static readonly AbsencesV2ControllerCreatePath = '/v2/absences';

  /**
   * Required permissions: absences:create, absences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `absencesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV2ControllerCreate$Response(
    params: {
      body: WorkCreateAbsenceV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbsence>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAbsencesV2Service.AbsencesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbsence>;
      })
    );
  }

  /**
   * Required permissions: absences:create, absences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `absencesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV2ControllerCreate(
    params: {
      body: WorkCreateAbsenceV2Dto
    },
    context?: HttpContext
  ): Observable<WorkAbsence> {
    return this.absencesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbsence>): WorkAbsence => r.body)
    );
  }

  /** Path part for operation `absencesV2ControllerAddDocumentToAbsence()` */
  static readonly AbsencesV2ControllerAddDocumentToAbsencePath = '/v2/absences/{id}/documents';

  /**
   * Required permissions: absences:update, absences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `absencesV2ControllerAddDocumentToAbsence()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV2ControllerAddDocumentToAbsence$Response(
    params: {
      id: number;
      body: WorkAddDocumentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAbsencesV2Service.AbsencesV2ControllerAddDocumentToAbsencePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: absences:update, absences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `absencesV2ControllerAddDocumentToAbsence$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV2ControllerAddDocumentToAbsence(
    params: {
      id: number;
      body: WorkAddDocumentDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.absencesV2ControllerAddDocumentToAbsence$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `absencesV2ControllerRemoveDocumentFromAbsence()` */
  static readonly AbsencesV2ControllerRemoveDocumentFromAbsencePath = '/v2/absences/{id}/documents';

  /**
   * Required permissions: absences:delete, absences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `absencesV2ControllerRemoveDocumentFromAbsence()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV2ControllerRemoveDocumentFromAbsence$Response(
    params: {
      id: number;
      body: WorkRemoveDocumentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAbsencesV2Service.AbsencesV2ControllerRemoveDocumentFromAbsencePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: absences:delete, absences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `absencesV2ControllerRemoveDocumentFromAbsence$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  absencesV2ControllerRemoveDocumentFromAbsence(
    params: {
      id: number;
      body: WorkRemoveDocumentDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.absencesV2ControllerRemoveDocumentFromAbsence$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
